<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>
<ng-container  *ngIf="!formSent">
    <div class="content-container">
        <h3>Jakie funkcjonalności Cię interesują?</h3>
        <div class="cards-list">
            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.FISCALIZATION)" (click)="toggleModule(SubscriptionModuleEnum.FISCALIZATION)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/fiskal.png">
                    <h5>POS z fiskalizacją</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.WEBSITE)" (click)="toggleModule(SubscriptionModuleEnum.WEBSITE)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/www.png">
                    <h5>Strona internetowa</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.MOBILE_APP)" (click)="toggleModule(SubscriptionModuleEnum.MOBILE_APP)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/mobile.png">
                    <h5>Aplikacja mobilna</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.QR_MENU_TABLE_ORDER)" (click)="toggleModule(SubscriptionModuleEnum.QR_MENU_TABLE_ORDER)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/qrmenu.png">
                    <h5>QR-Menu i zamawianie do stolika</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.KDS)" (click)="toggleModule(SubscriptionModuleEnum.KDS)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/kds.png">
                    <h5>KDS dla kuchni</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.INVENTORY)" (click)="toggleModule(SubscriptionModuleEnum.INVENTORY)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/magazyn.png">
                    <h5>Magazyn i inwentaryzacja</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.DRIVER)" (click)="toggleModule(SubscriptionModuleEnum.DRIVER)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/fast-delivery.png">
                    <h5>Aplikacja dla kierowców</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.KIOSK)" (click)="toggleModule(SubscriptionModuleEnum.KIOSK)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/kiosk.png">
                    <h5>Kiosk samoobsługowy</h5>
                </div>
            </div>

        </div>

    </div>
    <div class="content-container">
        <h3>Jaki masz rodzaj kuchni?</h3>
        <div class="cards-list">
            <div class="card" [class.active]="formData.typeSelected === 'RESTAURANT'" (click)="formData.typeSelected = 'RESTAURANT'">
                <div class="card-body">
                    <img src="assets/img/spaghetti.svg">
                    <h5>Restauracja ze stolikami</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'FOODTRACK'" (click)="formData.typeSelected = 'FOODTRACK'">
                <div class="card-body">
                    <img src="assets/img/pizza.svg">
                    <h5>Food truck</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'BAKERY'" (click)="formData.typeSelected = 'BAKERY'">
                <div class="card-body">
                    <img src="assets/img/pie.svg">
                    <h5>Piekarnia/Cukiernia</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'CAFFE'" (click)="formData.typeSelected = 'CAFFE'">
                <div class="card-body">
                    <img src="assets/img/salmon.svg">
                    <h5>Kawiarnia</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'BAR'" (click)="formData.typeSelected = 'BAR'">
                <div class="card-body">
                    <img src="assets/img/burger.svg">
                    <h5>Bar</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'OTHER'" (click)="formData.typeSelected = 'OTHER'">
                <div class="card-body">
                    <img src="assets/img/taco.svg">
                    <h5>Inny</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="content-container form-elem">
        <h3>Podaj nam dane, dzięki którym będziemy mogli się z Tobą skontaktować</h3>
        <div class="form mt-3">
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.name" [ngClass]="{ 'is-invalid':submitted && !formData.name}">
                    <label>Imię</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.phone"  [ngClass]="{ 'is-invalid':submitted && !formData.phone}">
                    <label>Numer telefonu</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.email"  [ngClass]="{ 'is-invalid':submitted && !formData.email}">
                    <label>E-mail</label>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="formData.havePOS">
                        Mam już system POS, który chce zmienić </label>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="formData.terms"  [ngClass]="{ 'is-invalid':submitted && !formData.terms}">
                        Akceptuje <a href="https://fodimi.pl/dokumenty/regulamin" target="_blank">regulamin</a></label>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button class="btn btn-primary" (click)="save()">Umów się na bezpłatny kontakt</button>
            <a  href="https://fodimi.pl"><button class="ml-2 btn btn-outline-primary">Wróć na stronę główną</button></a>
        </div>
    </div>
</ng-container>
<ng-container  *ngIf="formSent">
    <div class="content-container">
        <img src="assets/img/done.svg" width="100">
        <h4 class="mb-4 mt-4">Dziękujemy za wypełnienie formularza! Wkróte skontaktujemy się z Tobą aby przedstawić naszą ofertę</h4>
        <div class="text-center">
            <a  href="https://fodimi.pl"><button class="btn btn-primary">Wróć na stronę główną</button></a>
        </div>
    </div>

</ng-container>
